import React from 'react';
/**
 * @description avoid rendering of child components at SSR level. Carefully control inner content of that component
 */
export var ClientOnlyContent = function (_a) {
    var children = _a.children;
    if (typeof window === 'undefined') {
        return React.createElement("div", { suppressHydrationWarning: true });
    }
    return React.createElement("div", { suppressHydrationWarning: true }, children);
};
